import { render, staticRenderFns } from "./ModulePendenciesDetails.vue?vue&type=template&id=407c272b"
import script from "./ModulePendenciesDetails.vue?vue&type=script&lang=js"
export * from "./ModulePendenciesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports